import type { FC, ReactNode } from 'react'

import Reveal from '@/components/landing/reveal'
import LoveQuiz from '@/components/landing/love-quiz'
import OpenWhen from '@/components/landing/open-when'
import WishCake from '@/components/landing/wish-cake'
import SectionHeading from '@/components/landing/section-heading'
import { GAMES } from '@/constants/birthday'

const GamesSection: FC = (): ReactNode => {
    return (
        <section id='games' aria-labelledby='games-title' className='relative overflow-hidden bg-secondary/40 py-24 sm:py-32'>
            <div className='mx-auto max-w-6xl px-5 sm:px-8'>
                <Reveal>
                    <SectionHeading id='games-title' title={GAMES.title} />
                </Reveal>

                <div className='mt-14 grid gap-8 lg:grid-cols-2'>
                    <Reveal className='h-full'>
                        <WishCake />
                    </Reveal>

                    <Reveal delay={120} className='h-full'>
                        <LoveQuiz />
                    </Reveal>
                </div>

                <Reveal className='mt-8'>
                    <OpenWhen />
                </Reveal>
            </div>
        </section>
    )
}

export default GamesSection
